export function getEqualBreaks(min, max, nBreaks) {
  const breaks = [];

  if (min !== undefined && min !== null && max !== undefined && max !== null) {
    for (let i = 1; i <= nBreaks; i += 1) {
      const p = i / (nBreaks + 1);
      breaks.push((min + (max - min) * p).toFixed(0));
    }
  }

  return breaks;
}

export function getCorrectedBreaks(min, max, nBreaks) {
  const breaks = [];
  const range = max - min;

  if (min !== undefined && min !== null && max !== undefined && max !== null) {
    for (let i = 1; i <= nBreaks + 1; i += 1) {
      const p = 1 / 2 ** (nBreaks - i);
      breaks.push((range * p).toFixed(0));
    }
  }

  return breaks;
}
